import fetchData from "./axios-instance";
import {getAuthorizationHeader} from "../helpers/get-token";

const generateOpt = async (userId) => {
    const url = `/generate-opt`;
    const res = await fetchData.post(url, {"userId": userId}, {
        headers: { 'Authorization': getAuthorizationHeader() }
    });
    return res;
}

export default generateOpt;